<template>
  <div style="position: relative;">
    <el-form ref="flowSpecialistEveryoneAuditList" :model="flowSpecialistEveryoneAuditList" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="工单状态" prop="formFilter.flowStatus">
          <el-select class="filter-item" v-model="flowSpecialistEveryoneAuditList.formFilter.flowStatus" :clearable="true"
            placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
              :label="item.name" :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="flowSpecialistEveryoneAuditList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工单编号" prop="formFilter.workOrderCode">
          <el-input class="filter-item" v-model="flowSpecialistEveryoneAuditList.formFilter.workOrderCode"
            :clearable="true" placeholder="工单编号"
          />
        </el-form-item>
        <template v-if="toggleSearchStatus">
          <el-form-item label="流程状态" prop="formFilter.latestApprovalStatus">
            <el-select class="filter-item" v-model="flowSpecialistEveryoneAuditList.formFilter.latestApprovalStatus"
                       :clearable="true" filterable
                       placeholder="" :loading="flowSpecialistEveryoneAuditList.latestApprovalStatus.impl.loading"
                       @visible-change="flowSpecialistEveryoneAuditList.latestApprovalStatus.impl.onVisibleChange"
            >
              <el-option v-for="item in flowSpecialistEveryoneAuditList.latestApprovalStatus.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="申请人名称" prop="formFilter.queryForm.specialistName">
            <el-input class="filter-item" v-model="flowSpecialistEveryoneAuditList.formFilter.queryForm.specialistName"
                      :clearable="true" placeholder="申请人名称"
            />
          </el-form-item>
          <el-form-item label="联系电话" prop="formFilter.queryForm.mobilePhone">
            <el-input class="filter-item" v-model="flowSpecialistEveryoneAuditList.formFilter.queryForm.mobilePhone"
                      :clearable="true" placeholder="联系电话"
            />
          </el-form-item>
          <el-form-item label="工作单位" prop="formFilter.queryForm.companyName">
            <el-input class="filter-item" v-model="flowSpecialistEveryoneAuditList.formFilter.queryForm.companyName"
                      :clearable="true" placeholder="工作单位"
            />
          </el-form-item>

        </template>
        <!--        <div>-->
        <el-button @click="toggleSearchStatus = !toggleSearchStatus" slot="operator" type="primary" :size="defaultFormItemSize"
                   :icon="toggleSearchStatus ? 'up' : 'down'">
          {{ toggleSearchStatus ? '收起' : '展开' }}
        </el-button>

        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFlowSpecialistEveryoneAuditList(true)">查询</el-button>
<!--        <el-button slot="operator" type="primary" :size="defaultFormItemSize"-->
<!--          @click="onStartTaskClick()">-->
<!--          新建-->
<!--        </el-button>-->
        <el-button slot="operator" type="primary" :size="defaultFormItemSize"
                   :disabled="!checkPermCodeExist('specialist:specialist:export')"
                   @click="onExportClick()">
          导出
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialistEveryone" :data="specialistEveryoneWidget.dataList" :size="defaultFormItemSize"
          @sort-change="specialistEveryoneWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
            :index="specialistEveryoneWidget.getTableIndex"
          />
          <el-table-column label="工单编号" prop="workOrderCode" />
          <el-table-column label="名称" prop="masterData.specialistName">
          </el-table-column>
          <el-table-column label="专家照片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.masterData.specialistAvatar, {id: scope.row.masterData.id, fieldName: 'specialistAvatar', asImage: true})"
                :preview-src-list="getPictureList(scope.row.masterData.specialistAvatar, {id: scope.row.masterData.id, fieldName: 'specialistAvatar', asImage: true})"
                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" prop="masterData.mobilePhone">
          </el-table-column>
          <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
          <el-table-column label="流程创建时间" prop="createTime" />
          <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
          <el-table-column label="工单状态" prop="flowStatus"  width="100px">
            <template slot-scope="scope">
              <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" :size="defaultFormItemSize"
                v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
                @click.stop="onViewTaskClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey
                         && scope.row.flowStatus !==6"
                         @click.stop="onViewTaskClick(scope.row)">
                详情
              </el-button>

              <el-button type="text" :size="defaultFormItemSize"
                         v-if=" scope.row.flowStatus ===6"
                         @click.stop="onSpecialistViewClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="scope.row.createUserId === userInfo.userId && scope.row.flowStatus ===6"
                         @click.stop="onHandlerTaskClick(scope.row)">
                办理
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn"
                @click.stop="onRemindClick(scope.row)">
                催办
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                @click.stop="onCancelTaskClick(scope.row)">
                撤销
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialistEveryoneWidget.totalCount"
            :current-page="specialistEveryoneWidget.currentPage"
            :page-size="specialistEveryoneWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialistEveryoneWidget.onCurrentPageChange"
            @size-change="specialistEveryoneWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistEveryoneController, DictionaryController } from '@/api';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowSpecialistEveryAudit';
const processDefinitionName = '人人都是科特派认证管理';

export default {
  name: 'flowSpecialistEveryoneAuditList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      fit: 'scale-down',
      toggleSearchStatus: false,
      flowSpecialistEveryoneAuditList: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          queryForm: {specialistName: undefined}
        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          queryForm: {specialistName: undefined}
        },
        isInit: false,
        latestApprovalStatus: {
          impl: new DropdownWidget(this.loadLatestApprovalStatusDropdownList)
        }
      },

      specialistEveryoneWidget: new TableWidget(this.loadSpecialistEveryoneData, this.loadSpecialistEveryoneVerify, true),
      userInfo: {}
    }
  },
  methods: {
    onReset () {
      this.$refs.flowSpecialistEveryoneAuditList.resetFields();
      this.refreshFlowSpecialistEveryoneAuditList(true);
    },
    loadSpecialistEveryoneData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowSpecialistEveryoneAuditList.formFilterCopy.flowStatus,
          workOrderCode: this.flowSpecialistEveryoneAuditList.formFilterCopy.workOrderCode,
          createTimeStart: Array.isArray(this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime) ? this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime)
            ? this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime[1] : undefined,
          queryForm: this.flowSpecialistEveryoneAuditList.formFilterCopy.queryForm,
          latestApprovalStatus: this.flowSpecialistEveryoneAuditList.formFilterCopy.latestApprovalStatus
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        SpecialistEveryoneController.listWorkOrderFlowSpecialistEveryAudit(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadSpecialistEveryoneVerify () {
      this.flowSpecialistEveryoneAuditList.formFilterCopy.flowStatus = this.flowSpecialistEveryoneAuditList.formFilter.flowStatus;
      this.flowSpecialistEveryoneAuditList.formFilterCopy.workOrderCode = this.flowSpecialistEveryoneAuditList.formFilter.workOrderCode;
      this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime = this.flowSpecialistEveryoneAuditList.formFilter.createTime;
      this.flowSpecialistEveryoneAuditList.formFilterCopy.queryForm = this.flowSpecialistEveryoneAuditList.formFilter.queryForm;
      this.flowSpecialistEveryoneAuditList.formFilterCopy.latestApprovalStatus = this.flowSpecialistEveryoneAuditList.formFilter.latestApprovalStatus;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowSpecialistEveryoneAuditList.formFilterCopy.flowStatus,
          workOrderCode: this.flowSpecialistEveryoneAuditList.formFilterCopy.workOrderCode,
          createTimeStart: Array.isArray(this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime) ? this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime)
            ? this.flowSpecialistEveryoneAuditList.formFilterCopy.createTime[1] : undefined,
          queryForm: this.flowSpecialistEveryoneAuditList.formFilterCopy.queryForm,
          latestApprovalStatus: this.flowSpecialistEveryoneAuditList.formFilterCopy.latestApprovalStatus
        }
      };

      SpecialistEveryoneController.export(this, params, '人人都是科特派审核表.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    loadLatestApprovalStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysLatestApprovalStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否撤销此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动撤销'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('撤销成功！');
          this.refreshFlowSpecialistEveryoneAuditList();
        }).catch(e => {});
      }).catch(e => {});
    },
    // 刷新工单
    refreshFlowSpecialistEveryoneAuditList (reloadData = false) {
      if (reloadData) {
        this.specialistEveryoneWidget.refreshTable(true, 1);
      } else {
        this.specialistEveryoneWidget.refreshTable();
      }
      if (!this.flowSpecialistEveryoneAuditList.isInit) {
        // 初始化下拉数据
      }
      this.flowSpecialistEveryoneAuditList.isInit = true;
    },
    onResume () {
      this.refreshFlowSpecialistEveryoneAuditList();
    },
    formInit () {
      this.refreshFlowSpecialistEveryoneAuditList();
    },
    /**
     * 详情
     */
    onSpecialistViewClick (row) {
      let params = {
        processInstanceId: row.processInstanceId,
        viewFlag: 2,
        id: row.masterData.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'specialistInfoView', query: params});
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    this.userInfo = this.$store.state.userInfo
  },
  watch: {
  }
}
</script>

<style>
</style>
